"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = parseSeconds;

function parseSeconds(seconds) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      hideMillis = _ref.hideMillis;

  var minutes = "".concat(Math.floor(seconds / 60));
  var roundedSeconds = (seconds % 60).toFixed(2);
  var split = roundedSeconds.split('.');
  return "".concat(minutes.padStart(2, '0'), ":").concat(split[0].padStart(2, '0')).concat(!hideMillis ? ":".concat(split[1]) : '');
}